import { PublicPageTemplate } from "./PublicPageTemplate";

const SeminairePage = () => (
  <PublicPageTemplate
    badge="Séminaire"
    title="Séminaires"
    highlight="IA & Business"
    description="Des séminaires immersifs pour comprendre, maîtriser et déployer l'IA dans votre organisation."
  />
);
export default SeminairePage;
